import React, { type JSX } from 'react';
import styled from 'styled-components';
import { StyledSystemProps } from '../../types';
import { theme } from '../../theme';
import { Typography } from '../Typography';
import { Box } from '../../wag-react/next-components/box';
import { TextArea as WaglabsTextArea } from '../../wag-react/core-components/control/TextArea';
type Props = StyledSystemProps & JSX.IntrinsicElements['textarea'] & {
  value?: string;
  label?: string;
  name?: string;
  containerProps?: StyledSystemProps;
  error?: boolean;
  helperText?: string;
  helperTextProps?: StyledSystemProps;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ref?: any;
};
const StyledTextArea = styled(WaglabsTextArea)`
  outline: none;
  font-family: Muli, Helvetica, Arial, sans-serif;
  padding: 10px;
  &::placeholder: {
    font-family: Muli;
  }
`;
export const TextArea = ({
  label,
  helperText,
  helperTextProps,
  error,
  containerProps,
  ...rest
}: Props) => <Box {...containerProps} data-sentry-element="Box" data-sentry-component="TextArea" data-sentry-source-file="index.tsx">
    <StyledTextArea width={1} maxLength={600} minLength={20} fontSize={4} placeholder={label} bg={`${theme.colors.backgroundGray} !important`} color={theme.colors.medGray} border={error ? '1px solid red !important' : 'none'} {...rest} data-sentry-element="StyledTextArea" data-sentry-source-file="index.tsx" />
    {helperText && <Typography variant="legal" color={error ? 'red' : 'initial'} {...helperTextProps}>
        {helperText}
      </Typography>}
  </Box>;
export type TextAreaProps = Props;